module.exports = __webpack_public_path__ + "img/01080201.401bc980.png";